document.addEventListener('DOMContentLoaded', function() {
  // Tab Functionality
  const tabButtons = document.querySelectorAll('.tab-btn');
  const tabPanes = document.querySelectorAll('.tab-pane');

  tabButtons.forEach(button => {
    button.addEventListener('click', function() {
      // Remove active class from all buttons and panes
      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabPanes.forEach(pane => pane.classList.remove('active'));
      
      // Add active class to current button
      this.classList.add('active');
      
      // Get the color data attribute and apply it to the active tab
      const activeColor = this.getAttribute('data-color');
      this.style.backgroundColor = activeColor;
      
      // Reset background color of other tabs
      tabButtons.forEach(btn => {
        if (!btn.classList.contains('active')) {
          btn.style.backgroundColor = '';
        }
      });
      
      // Show corresponding tab content
      const tabId = this.getAttribute('data-tab');
      document.getElementById(tabId).classList.add('active');
    });
  });

  // Mobile Dropdown Functionality
  const selectSelected = document.querySelector('.tabs-colours-section .select-selected');
  const selectItems = document.querySelector('.tabs-colours-section .select-items');
  const selectOptions = document.querySelectorAll('.tabs-colours-section .select-items div');

  if (selectSelected && selectItems) {
    // Ensure dropdown is hidden initially
    selectItems.classList.add('select-hide');
    
    // Toggle dropdown when clicking on selected
    selectSelected.addEventListener('click', function(e) {
      e.stopPropagation();
      this.classList.toggle('select-arrow-active');
      selectItems.classList.toggle('select-hide');
    });

    // Handle option selection
    selectOptions.forEach(option => {
      option.addEventListener('click', function(e) {
        e.stopPropagation();
        
        // Update selected text
        selectSelected.textContent = this.textContent;
        
        // Close dropdown
        selectSelected.classList.remove('select-arrow-active');
        selectItems.classList.add('select-hide');
        
        // Switch tabs
        const tabId = this.getAttribute('data-tab');
        const tabColor = this.getAttribute('data-color');
        
        // Remove active class from all tabs and panes
        tabButtons.forEach(btn => btn.classList.remove('active'));
        tabPanes.forEach(pane => pane.classList.remove('active'));
        
        // Find and activate the corresponding desktop tab button
        const correspondingTabBtn = document.querySelector(`.tab-btn[data-tab="${tabId}"]`);
        if (correspondingTabBtn) {
          correspondingTabBtn.classList.add('active');
        }
        
        // Show corresponding tab content
        const targetPane = document.getElementById(tabId);
        if (targetPane) {
          targetPane.classList.add('active');
        }
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function() {
      selectSelected.classList.remove('select-arrow-active');
      selectItems.classList.add('select-hide');
    });
  }

  // Initialize Before-After Slider
  const beforeAfterSlider = new Swiper('.before-after-slider', {
    slidesPerView: 1,
    spaceBetween: 24,
    loop: true,
    grabCursor: true,
    speed: 600,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    centerInsufficientSlides: true,
    pagination: {
      el: '.before-after-container .slider_dot',
      clickable: true,
    },
    navigation: {
      nextEl: '.before-after-container .slider_arrow--next',
      prevEl: '.before-after-container .slider_arrow--prev',
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
    },
  });
});
